import { gql } from "apollo-boost";

export const UPDATE_BOOKING = gql`
  mutation updateBooking(
    $bookingId: ID!
    $status: BOOKING_STATE!
    $rejectReason: String
  ) {
    updateBooking(
      bookingId: $bookingId
      status: $status
      rejectReason: $rejectReason
    )
  }
`;

export const CREATE_IN_PROGRESS_BOOKING = gql`
  mutation createInProgressBooking($booking: BookingInput!) {
    createInProgressBooking(booking: $booking)
  }
`;

export const UPDATE_IN_PROGRESS_BOOKING = gql`
  mutation updateInProgressBooking($bookingId: ID!, $booking: BookingInput!) {
    updateInProgressBooking(bookingId: $bookingId, booking: $booking)
  }
`;

export const DELETE_IN_PROGRESS_BOOKING = gql`
    mutation removeInProgressBooking($bookingId: ID!) {
        removeInProgressBooking(bookingId: $bookingId)
    }
`;

export const CREATE_BOOKING = gql`
  mutation createBooking($bookingId: ID!) {
    createBooking(bookingId: $bookingId)
  }
`;

export const CANCEL_BOOKING = gql`
  mutation cancelBooking($bookingId: ID!) {
    cancelBooking(bookingId: $bookingId)
  }
`;

export const MAKE_PROPOSAL = gql`
    mutation makeProposal($id: ID!, $proposedDate: Date, $proposedTime: String, $proposedTimeEnd: String, $proposedAmount: Float, $proposalComments: String, $isCounterProposal: Boolean) {
        makeProposal(id: $id, proposedDate: $proposedDate, proposedTime: $proposedTime, proposedTimeEnd: $proposedTimeEnd, proposedAmount: $proposedAmount, proposalComments: $proposalComments, isCounterProposal: $isCounterProposal)
    }
`;

export const UPDATE_PROPOSAL_READ = gql`
  mutation updateProposalRead($id: ID!) {
      updateProposalRead(id: $id)
  }
`;
